/**
 * Aviator — the crowd. FIREWALLED like roulette's social.ts: imports nothing
 * from the money path, and everything it returns is a PURE FUNCTION of
 * (tableSeed, roundNo) — two phones on the same table render the same
 * crowd (plan §5.4). Amounts are display strings' worth of theatre; the
 * only number that leaves this file is a cashout multiplier for the ticker.
 */
import { mulberry32, mix } from './prng';

const NAMES = [
  'Ravi', 'Priya', 'Manish', 'Farhan', 'Amrutha', 'Vikram', 'Sana', 'Deepak',
  'Kavya', 'Arjun', 'Neha', 'Rohit', 'Ishaan', 'Pooja', 'Salman', 'Anita',
  'Tarun', 'Meera', 'Zoya', 'Karan', 'Bhavna', 'Nikhil', 'Rehan', 'Simran',
];
export const mask = (n: string) => n.slice(0, 2) + '**' + n.slice(-1);

export type FakeBettor = {
  id: string;
  name: string;         // already masked
  stake: number;
  /** the X at which this bettor cashes out, or null = rides it to the crash */
  cashX: number | null;
};

const STAKES = [10, 50, 100, 100, 100, 500, 500, 1000, 5000];

/** the crowd for one round: 14–38 bettors, stakes lumpy, cashout points
 *  clustered where real people cash (X1.3–X2.5) with a brave tail */
export function crowdFor(tableSeed: number, roundNo: number): FakeBettor[] {
  const rnd = mulberry32(mix(tableSeed, roundNo));
  const n = 14 + Math.floor(rnd() * 25);
  const out: FakeBettor[] = [];
  for (let i = 0; i < n; i++) {
    const name = mask(NAMES[Math.floor(rnd() * NAMES.length)]);
    const stake = STAKES[Math.floor(rnd() * STAKES.length)];
    const r = rnd();
    let cashX: number | null;
    if (r < 0.12) cashX = null;                                   // rides to the crash
    else if (r < 0.70) cashX = 1.2 + rnd() * 1.3;                 // the sensible crowd
    else if (r < 0.92) cashX = 2.5 + rnd() * 4;                   // the confident
    else cashX = 6.5 + rnd() * 20;                                // the brave
    out.push({ id: `f${roundNo}-${i}`, name, stake, cashX: cashX == null ? null : Math.floor(cashX * 100) / 100 });
  }
  return out;
}

/** the leaderboard standings for the table session — a stateless replay so
 *  every viewer agrees (plan §5.4). Standings scale with the table's max bet. */
export function standingsFor(tableSeed: number, roundNo: number, maxBet: number): { name: string; net: number }[] {
  const rnd = mulberry32(mix(tableSeed ^ 0x51ED, Math.floor(roundNo / 6)));
  const rows = Array.from({ length: 3 }, (_, i) => ({
    name: mask(NAMES[(Math.floor(rnd() * NAMES.length) + i * 7) % NAMES.length]),
    net: Math.round((8 + rnd() * 32) * maxBet / 10) * 10,
  }));
  return rows.sort((a, b) => b.net - a.net);
}

/** table-level seat count, mean-reverting around a base */
export function seatsFor(tableSeed: number, roundNo: number): number {
  const rnd = mulberry32(mix(tableSeed ^ 0xA11, roundNo));
  return 120 + Math.floor(rnd() * 260);
}
